var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4746 13.0006L10.9158 9.46751C11.8309 8.4292 12.3322 7.12281 12.3322 5.76279C12.3322 2.58524 9.62388 0 6.29502 0C2.96616 0 0.257812 2.58524 0.257812 5.76279C0.257812 8.94034 2.96616 11.5256 6.29502 11.5256C7.54472 11.5256 8.73562 11.1658 9.75381 10.4828L13.3396 14.0427C13.4895 14.1912 13.6911 14.2732 13.9071 14.2732C14.1116 14.2732 14.3056 14.1988 14.4529 14.0635C14.7657 13.7761 14.7757 13.2995 14.4746 13.0006ZM6.29502 1.50334C8.75557 1.50334 10.7573 3.41408 10.7573 5.76279C10.7573 8.1115 8.75557 10.0222 6.29502 10.0222C3.83446 10.0222 1.83274 8.1115 1.83274 5.76279C1.83274 3.41408 3.83446 1.50334 6.29502 1.50334Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.77a54596a855fb046c72b70db122c29d.svg";
export { ForwardRef as ReactComponent };